import React, { useState } from 'react';
import styles from './RulesControl.module.css';

import LayoutDefault from '../../Components/LayoutDefault/LayoutDefault';
import Panel from '../../Components/Panel/Panel';
import Rules from './Rules/Rules';
import RulesInsert from './RulesInsert/RulesInsert';
import Topics from './Topics/Topics';

import { FaList, FaCog, FaPlus } from 'react-icons/fa'; // Ícones para o menu inferior

function RulesControl() {
    const [selectedsRules, setSelectedsRules] = useState([]);
    const [reloadRules, setReloadRules] = useState(null);
    const [selectedsTopics, setSelectedsTopics] = useState([]);

    const [activeTab, setActiveTab] = useState('topics');

    const mainPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
    };

    const isMobile = window.innerWidth <= 786;

    return (
        <LayoutDefault>
            {/* Painel 1: Tópicos */}
            {(activeTab === 'topics' || !isMobile) && (
                <Topics
                    className={'main-modal two left'}
                    style={{
                        ...mainPanelStyle,
                        '--modal-width-left': isMobile ? '100%' : '20%'
                    }}
                    titlePage={'Topicos'}
                    onSelectedsChange={setSelectedsTopics}
                    statusRules={'A'}
                />
            )}

            {/* Painel 2: Regras */}
            {(activeTab === 'rules' || !isMobile) && (
                <Panel
                    className={'main-modal two three middle'}
                    style={{
                        ...mainPanelStyle,
                        '--modal-width-middle': isMobile ? '100%' : '40%'
                    }}
                >
                    <Rules
                        subjectRuleId={selectedsTopics ? selectedsTopics[0] : null}
                        setSelectedsRules={setSelectedsRules}
                        selectedsRules={selectedsRules}
                        setReloadRules={setReloadRules}
                        reloadRules={reloadRules}
                    />
                </Panel>
            )}

            {/* Painel 3: Inserir Regras */}
            {(activeTab === 'rulesInsert' || !isMobile) && (
                <Panel
                    className={'main-modal two three right'}
                    style={{
                        ...mainPanelStyle,
                        '--modal-width-right': isMobile ? '100%' : '40%'
                    }}
                >
                    <RulesInsert
                        subjectRuleId={selectedsTopics ? selectedsTopics[0] : null}
                        selectedsRules={selectedsRules}
                        setReloadRules={setReloadRules}
                    />
                </Panel>
            )}


            {/* Navegação inferior para mobile */}
            {isMobile && (
                <div className={styles.bottomNav}>
                    <button
                        className={`${styles.navButton} ${activeTab === 'topics' ? styles.active : ''}`}
                        onClick={() => setActiveTab('topics')}
                    >
                        <FaList />
                        <span>Tópicos</span>
                    </button>
                    <button
                        className={`${styles.navButton} ${activeTab === 'rules' ? styles.active : ''}`}
                        onClick={() => setActiveTab('rules')}
                    >
                        <FaCog />
                        <span>Regras</span>
                    </button>
                    <button
                        className={`${styles.navButton} ${activeTab === 'rulesInsert' ? styles.active : ''}`}
                        onClick={() => setActiveTab('rulesInsert')}
                    >
                        <FaPlus />
                        <span>Inserir</span>
                    </button>
                </div>
            )}
        </LayoutDefault>
    );
}

export default RulesControl;
